import React, { useState, useEffect } from 'react';
import JalaliDatePicker from '../../components/JalaliDatePicker';

const toFa = n => n===null||n===undefined?'':String(n).replace(/[0-9]/g,d=>'۰۱۲۳۴۵۶۷۸۹'[d]);
const toEng = s => String(s).replace(/[۰-۹]/g,d=>'۰۱۲۳۴۵۶۷۸۹'.indexOf(d).toString());
const numFmt = n => n ? Number(n).toLocaleString('fa-IR') : '•';
const si = v => { try{return parseInt(toEng(String(v||0)),10)||0;}catch{return 0;} };

async function API(path, opts={}){
  const doFetch=()=>fetch(`/api/accounting${path}`,{
    headers:{'Content-Type':'application/json',Authorization:`Bearer ${localStorage.getItem('access')}`},...opts});
  let res=await doFetch();
  if(res.status===401){
    const rr=await fetch('/api/auth/token/refresh/',{method:'POST',
      headers:{'Content-Type':'application/json'},
      body:JSON.stringify({refresh:localStorage.getItem('refresh')})});
    if(rr.ok){const d=await rr.json();localStorage.setItem('access',d.access);res=await doFetch();}
  }
  return res.json();
}

export default function AutoDocumentModal({ year, onClose, onCreated }) {
  const [patterns,   setPatterns]   = useState([]);
  const [patternId,  setPatternId]  = useState('');
  const [docFrom,    setDocFrom]    = useState('');
  const [docTo,      setDocTo]      = useState('');
  const [exc1,       setExc1]       = useState('');
  const [exc2,       setExc2]       = useState('');

  // سند اختتامیه
  const [finalNo,    setFinalNo]    = useState('');
  const [finalDate,  setFinalDate]  = useState('');
  const [finalMode,  setFinalMode]  = useState('normal'); // normal | reverse

  // سند افتتاحیه
  const [beginNo,    setBeginNo]    = useState('');
  const [beginDate,  setBeginDate]  = useState('');

  const [preview,    setPreview]    = useState([]);
  const [totD,       setTotD]       = useState(0);
  const [totC,       setTotC]       = useState(0);
  const [loading,    setLoading]    = useState(false);
  const [saving,     setSaving]     = useState(false);
  const [error,      setError]      = useState('');
  const [toast,      setToast]      = useState('');
  const [step,       setStep]       = useState('setup'); // setup | preview

  const showToast = msg => { setToast(msg); setTimeout(()=>setToast(''),4000); };

  useEffect(() => {
    API(`/auto-document/patterns/?year=${year}`).then(j => {
      if (j.ok) {
        setPatterns(j.patterns);
        if (j.patterns.length===1) setPatternId(String(j.patterns[0].id));
        setDocFrom(toFa(j.doc_from));
        setDocTo(toFa(j.doc_to));
      }
    });
    API(`/documents/next-no/?year=${year}`).then(j => {
      if (j.ok) {
        setFinalNo(toFa(j.next_no));
        setBeginNo(toFa(si(j.next_no)+1));
        setFinalDate(j.last_date||'');
      }
    });
  }, [year]);

  const calcPreview = async () => {
    if (!patternId) { setError('الگو انتخاب نشده'); return; }
    setLoading(true); setError('');
    const j = await API('/auto-document/preview/', { method:'POST', body: JSON.stringify({
      pattern_id: si(patternId),
      year: si(toEng(String(year))),
      doc_from: si(toEng(docFrom)),
      doc_to: si(toEng(docTo)),
      transferal_type: 0,
      exception_code1: si(toEng(exc1)),
      exception_code2: si(toEng(exc2)),
    })});
    setLoading(false);
    if (j.ok) { setPreview(j.data); setTotD(j.total_debit); setTotC(j.total_credit); setStep('preview'); }
    else setError(j.msg);
  };

  const createDoc = async (mode) => {
    // حالت‌ها: final_normal | final_reverse | begin
    const isFinal  = mode !== 'begin';
    const isReverse= mode === 'final_reverse' || mode === 'begin';
    const isNextYear = mode === 'begin';
    const docNo   = isFinal ? si(toEng(finalNo)) : si(toEng(beginNo));
    const docDate = isFinal ? finalDate : beginDate;

    if (!docDate) { setError('تاریخ سند را وارد کنید'); return; }
    setSaving(true); setError('');

    const patName = patterns.find(p=>String(p.id)===patternId)?.name||'';
    const j = await API('/auto-document/create/', { method:'POST', body: JSON.stringify({
      year: si(toEng(String(year))),
      doc_no: docNo,
      doc_date: docDate,
      doc_remark: patName,
      next_year_mode: isNextYear,
      reverse_mode: isReverse,
      rows: preview,
    })});
    setSaving(false);
    if (j.ok) { showToast(j.msg); onCreated && onCreated(); }
    else setError(j.msg);
  };

  const patName = patterns.find(p=>String(p.id)===patternId)?.name||'';

  return (
    <div style={s.overlay} onClick={onClose}>
      <div style={s.modal} onClick={e=>e.stopPropagation()}>

        {/* هدر */}
        <div style={s.hdr}>
          <div>
            <div style={{fontSize:'15px',fontWeight:'700',color:'#fff'}}>
              📊 ایجاد سند اختتامیه / افتتاحیه
            </div>
            <div style={{fontSize:'11px',color:'rgba(255,255,255,0.6)',marginTop:'2px'}}>
              سال {toFa(year)}
            </div>
          </div>
          <button onClick={onClose} style={s.xBtn}>✕</button>
        </div>

        {/* تب‌ها */}
        <div style={{display:'flex',background:'#f8f9fa',borderBottom:'1px solid #e0e0e0',flexShrink:0}}>
          {[['setup','۱. تنظیمات'],['preview','۲. محاسبه و نتیجه']].map(([id,lbl])=>(
            <div key={id} onClick={()=>id==='setup'?setStep('setup'):(preview.length>0&&setStep('preview'))}
              style={{flex:1,padding:'10px',textAlign:'center',fontSize:'12px',fontWeight:'600',
                cursor:'pointer',
                background:step===id?'#1a2f50':'transparent',
                color:step===id?'#C8A84B':'#999',
                borderBottom:step===id?'2px solid #C8A84B':'2px solid transparent'}}>
              {lbl}
            </div>
          ))}
        </div>

        <div style={s.body}>
          {error && <div style={s.err}>⚠️ {error}</div>}

          {/* ── مرحله ۱ ── */}
          {step==='setup' && (<>
            {/* انتخاب الگو */}
            <div style={s.card}>
              <div style={s.cardTitle}>🗂️ الگوی ثبت اسناد</div>
              <div style={{display:'flex',gap:'8px',flexWrap:'wrap'}}>
                {patterns.map(p=>(
                  <button key={p.id} onClick={()=>setPatternId(String(p.id))}
                    style={{padding:'9px 16px',borderRadius:'8px',cursor:'pointer',fontSize:'13px',
                      fontWeight:patternId===String(p.id)?'700':'400',
                      background:patternId===String(p.id)?'#1a2f50':'#f5f5f5',
                      color:patternId===String(p.id)?'#C8A84B':'#555',
                      border:`2px solid ${patternId===String(p.id)?'#C8A84B':'#e0e0e0'}`}}>
                    <div style={{fontSize:'13px'}}>
                      {p.code ? p.code+' — ' : ''}{p.name || 'الگوی '+toFa(p.id)}
                    </div>
                    {p.description && <div style={{fontSize:'10px',opacity:.7,marginTop:'2px'}}>{p.description}</div>}
                    <div style={{fontSize:'10px',opacity:.6,marginTop:'2px'}}>{toFa(p.detail_count)} ردیف</div>
                  </button>
                ))}
              </div>
            </div>

            {/* بازه سند */}
            <div style={s.card}>
              <div style={s.cardTitle}>📋 بازه شماره سند</div>
              <div style={{display:'flex',gap:'12px',flexWrap:'wrap',alignItems:'flex-end'}}>
                <div style={s.fld}>
                  <label style={s.lbl}>از سند</label>
                  <input value={docFrom} onChange={e=>setDocFrom(e.target.value)} style={s.inp}/>
                </div>
                <div style={s.fld}>
                  <label style={s.lbl}>تا سند</label>
                  <input value={docTo} onChange={e=>setDocTo(e.target.value)} style={s.inp}/>
                </div>
                <div style={s.fld}>
                  <label style={s.lbl}>استثنا ۱</label>
                  <input value={exc1} onChange={e=>setExc1(e.target.value)} style={{...s.inp,width:'90px'}} placeholder="شماره سند"/>
                </div>
                <div style={s.fld}>
                  <label style={s.lbl}>استثنا ۲</label>
                  <input value={exc2} onChange={e=>setExc2(e.target.value)} style={{...s.inp,width:'90px'}} placeholder="شماره سند"/>
                </div>
              </div>
            </div>

            <div style={{textAlign:'left'}}>
              <button onClick={calcPreview} disabled={loading||!patternId}
                style={{...s.btnP, opacity:(!patternId||loading)?0.5:1}}>
                {loading ? '⏳ در حال محاسبه...' : '🔢 محاسبه مانده حساب‌ها'}
              </button>
            </div>
          </>)}

          {/* ── مرحله ۲ ── */}
          {step==='preview' && (<>
            {/* خلاصه */}
            <div style={{display:'flex',gap:'10px',marginBottom:'12px',flexWrap:'wrap',alignItems:'center'}}>
              <span style={s.badge('#1b5e20')}>اقلام: {toFa(preview.length)}</span>
              <span style={s.badge('#b71c1c')}>بدهکار: {numFmt(totD)}</span>
              <span style={s.badge('#1976d2')}>بستانکار: {numFmt(totC)}</span>
              {totD===totC
                ? <span style={s.badge('#1b5e20')}>✅ تراز</span>
                : <span style={s.badge('#e65100')}>⚠️ مانده: {numFmt(Math.abs(totD-totC))}</span>}
              <span style={{fontSize:'11px',color:'#777'}}>الگو: {patName}</span>
              <button onClick={()=>setStep('setup')} style={{...s.btnS,marginRight:'auto'}}>← تنظیمات</button>
            </div>

            {/* جدول پیش‌نمایش */}
            <div style={{flex:1,overflowX:'auto',overflowY:'auto',borderRadius:'8px',
              boxShadow:'0 1px 6px rgba(0,0,0,0.1)',marginBottom:'14px'}}>
              <table style={{width:'100%',borderCollapse:'collapse',direction:'rtl'}}>
                <thead>
                  <tr>
                    {['#','کد معین','عنوان حساب','بدهکار','بستانکار'].map(h=>(
                      <th key={h} style={{...s.th,
                        background:h==='بدهکار'?'#1a3a2a':h==='بستانکار'?'#0d3020':'#1a2f50',
                        color:h==='بدهکار'?'#ef9a9a':h==='بستانکار'?'#a5d6a7':'#fff'}}>
                        {h}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {preview.map((r,i)=>(
                    <tr key={i} style={{background:r.is_sum?'#fff3e0':i%2===0?'#fff':'#fafafa'}}>
                      <td style={s.td}>{toFa(i+1)}</td>
                      <td style={s.td}>{toFa(r.sub_coding_code)}</td>
                      <td style={{...s.td,textAlign:'right',maxWidth:'220px',
                        overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>
                        {r.sub_coding_name}
                      </td>
                      <td style={{...s.td,color:r.debit>0?'#b71c1c':'#ccc',fontWeight:'700',fontFamily:'monospace'}}>
                        {r.debit>0?numFmt(r.debit):'•'}
                      </td>
                      <td style={{...s.td,color:r.credit>0?'#1b5e20':'#ccc',fontWeight:'700',fontFamily:'monospace'}}>
                        {r.credit>0?numFmt(r.credit):'•'}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {/* دو ستون: اختتامیه | افتتاحیه */}
            <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:'12px'}}>

              {/* سند اختتامیه */}
              <div style={s.docCard}>
                <div style={s.docTitle}>📕 سند اختتامیه — سال {toFa(year)}</div>
                <div style={s.fld}>
                  <label style={s.lbl}>شماره سند اختتامیه</label>
                  <input value={toFa(finalNo)} onChange={e=>setFinalNo(e.target.value)} style={s.inp}/>
                </div>
                <div style={s.fld}>
                  <label style={s.lbl}>تاریخ</label>
                  <JalaliDatePicker value={finalDate} onChange={v=>setFinalDate(v)} placeholder="انتخاب تاریخ"/>
                </div>
                {/* معمولی / معکوس */}
                <div style={{display:'flex',gap:'8px',margin:'8px 0'}}>
                  {[['normal','معمولی (coef=1)'],['reverse','معکوس (coef=-1)']].map(([v,l])=>(
                    <label key={v} style={{display:'flex',alignItems:'center',gap:'5px',cursor:'pointer',
                      padding:'5px 10px',borderRadius:'6px',fontSize:'11px',fontWeight:'600',
                      background:finalMode===v?'#e8eaf6':'#f5f5f5',
                      border:`1.5px solid ${finalMode===v?'#7986cb':'#e0e0e0'}`,
                      color:finalMode===v?'#1a237e':'#666'}}>
                      <input type="radio" value={v} checked={finalMode===v}
                        onChange={()=>setFinalMode(v)} style={{width:'13px',height:'13px'}}/>
                      {l}
                    </label>
                  ))}
                </div>
                <button onClick={()=>createDoc(finalMode==='normal'?'final_normal':'final_reverse')}
                  disabled={saving||totD!==totC||!finalDate}
                  title={totD!==totC?'سند تراز نیست':''}
                  style={{...s.btnP,width:'100%',
                    opacity:(saving||totD!==totC||!finalDate)?0.4:1,
                    background:'linear-gradient(135deg,#b71c1c,#c62828)'}}>
                  {saving?'⏳...':'💾 ایجاد سند اختتامیه'}
                </button>
              </div>

              {/* سند افتتاحیه */}
              <div style={s.docCard}>
                <div style={s.docTitle}>📗 سند افتتاحیه — سال {toFa(si(toEng(String(year)))+1)}</div>
                <div style={s.fld}>
                  <label style={s.lbl}>شماره سند افتتاحیه</label>
                  <input value={toFa(beginNo)} onChange={e=>setBeginNo(e.target.value)} style={s.inp}/>
                </div>
                <div style={s.fld}>
                  <label style={s.lbl}>تاریخ</label>
                  <JalaliDatePicker value={beginDate} onChange={v=>setBeginDate(v)} placeholder="انتخاب تاریخ"/>
                </div>
                <div style={{fontSize:'11px',color:'#777',margin:'8px 0',lineHeight:'1.6'}}>
                  کدهای معین تبدیل می‌شوند:<br/>
                  93001→91501 | 93002→91502 | 95001→91501 | ...<br/>
                  <span style={{color:'#e65100',fontWeight:'600'}}>همیشه معکوس (coef=-1)</span>
                </div>
                <button onClick={()=>createDoc('begin')}
                  disabled={saving||totD!==totC||!beginDate}
                  title={totD!==totC?'سند تراز نیست':''}
                  style={{...s.btnP,width:'100%',marginTop:'auto',
                    opacity:(saving||totD!==totC||!beginDate)?0.4:1,
                    background:'linear-gradient(135deg,#1b5e20,#2e7d32)'}}>
                  {saving?'⏳...':'💾 ایجاد سند افتتاحیه'}
                </button>
              </div>
            </div>
          </>)}
        </div>

        {toast && (
          <div style={{position:'absolute',bottom:'14px',right:'14px',
            background:'#1b5e20',color:'#fff',padding:'10px 20px',
            borderRadius:'8px',fontSize:'13px',fontWeight:'600',zIndex:10}}>
            {toast}
          </div>
        )}
      </div>
    </div>
  );
}

const s = {
  overlay:   {position:'fixed',inset:0,background:'rgba(0,0,0,0.65)',zIndex:3000,
               display:'flex',alignItems:'center',justifyContent:'center',padding:'12px'},
  modal:     {background:'#f0f2f7',borderRadius:'14px',width:'100%',maxWidth:'900px',
               maxHeight:'90vh',display:'flex',flexDirection:'column',
               boxShadow:'0 24px 64px rgba(0,0,0,0.5)',overflow:'hidden',position:'relative'},
  hdr:       {display:'flex',justifyContent:'space-between',alignItems:'flex-start',
               padding:'14px 18px',background:'linear-gradient(135deg,#0a1628,#1a2f50)',flexShrink:0},
  xBtn:      {background:'rgba(255,255,255,0.15)',border:'1px solid rgba(255,255,255,0.3)',
               color:'#fff',width:'28px',height:'28px',borderRadius:'50%',cursor:'pointer',
               fontSize:'12px',display:'flex',alignItems:'center',justifyContent:'center'},
  body:      {flex:1,overflowY:'auto',padding:'14px',display:'flex',flexDirection:'column',gap:'10px'},
  err:       {background:'#fff3f3',border:'1px solid #ffcdd2',borderRadius:'7px',
               padding:'8px 12px',color:'#c62828',fontSize:'12px'},
  card:      {background:'#fff',borderRadius:'10px',padding:'14px',
               boxShadow:'0 1px 4px rgba(0,0,0,0.08)'},
  cardTitle: {fontSize:'12px',fontWeight:'700',color:'#1a2f50',marginBottom:'10px',
               paddingBottom:'5px',borderBottom:'1.5px solid #e8eaf6'},
  docCard:   {background:'#fff',borderRadius:'10px',padding:'14px',
               boxShadow:'0 1px 4px rgba(0,0,0,0.08)',display:'flex',flexDirection:'column',gap:'8px'},
  docTitle:  {fontSize:'12px',fontWeight:'700',color:'#1a2f50',paddingBottom:'5px',
               borderBottom:'1.5px solid #e8eaf6'},
  fld:       {display:'flex',flexDirection:'column',gap:'3px'},
  lbl:       {fontSize:'11px',fontWeight:'600',color:'#555'},
  inp:       {padding:'7px 10px',border:'1.5px solid #e0e0e0',borderRadius:'7px',fontSize:'12px',
               fontFamily:"'Vazirmatn',Tahoma,sans-serif",outline:'none',
               direction:'rtl',textAlign:'right',width:'120px',boxSizing:'border-box'},
  th:        {padding:'7px 9px',fontSize:'11px',fontWeight:'700',textAlign:'center',whiteSpace:'nowrap',position:'sticky',top:0,zIndex:2},
  td:        {padding:'5px 8px',fontSize:'11px',textAlign:'center',
               borderBottom:'1px solid #f0f0f0',whiteSpace:'nowrap'},
  btnP:      {padding:'9px 20px',background:'linear-gradient(135deg,#1a2f50,#1a237e)',
               color:'#fff',border:'none',borderRadius:'8px',cursor:'pointer',
               fontFamily:'inherit',fontSize:'13px',fontWeight:'700'},
  btnS:      {padding:'7px 14px',background:'#e0e0e0',color:'#333',border:'none',
               borderRadius:'7px',cursor:'pointer',fontFamily:'inherit',fontSize:'12px'},
  badge:     bg => ({padding:'5px 12px',background:bg,color:'#fff',
               borderRadius:'16px',fontSize:'12px',fontWeight:'700'}),
};